<template>
      <Breadcrumbs main="Email" title="Email Application" />
      <div class="container-fluid">
            <div class="email-wrap">
              <div class="row">
                <emailSidebar />
                <emaillApp/>
              </div>
            </div>
            </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const emailSidebar = defineAsyncComponent(() => import("@/components/commen/emailSidebar.vue"))
const emaillApp = defineAsyncComponent(() => import("@/components/theme/email/app/emaillApp.vue"))

</script>